import type { Action } from 'redux';

import type { Message } from 'types/entities/message';

import type {
  CHANGE_MESSAGES_WINDOW_STATE,
  SET_DELETED_CLIENT_MESSAGES,
  SET_DELETED_PRACTICE_MESSAGES,
  SET_NEW_CLIENT_MESSAGES,
  SET_NEW_PRACTICE_MESSAGES,
} from './actionTypes';

export enum MessagesStates {
  ClientMessagesOpen = 'ClientMessagesOpen',
  ClientPracticeMessagesOpen = 'ClientPracticeMessagesOpen',
  MessagesClosed = 'MessagesClosed',
}

export interface MessagesState {
  messagesState: MessagesStates;
  newClientMessages: Message[];
  newPracticeMessages: Message[];
  deletedClientMessages: Record<number, Message>;
  deletedPracticeMessages: Record<number, Message>;
}

export type ChangeMessagesStateAction = Action<typeof CHANGE_MESSAGES_WINDOW_STATE> & {
  messagesState: MessagesStates;
};

export type SetNewClientMessagesAction = Action<typeof SET_NEW_CLIENT_MESSAGES> & {
  newClientMessages: Message[];
};

export type SetNewPracticeMessagesAction = Action<typeof SET_NEW_PRACTICE_MESSAGES> & {
  newPracticeMessages: Message[];
};

export type SetDeletedClientMessagesAction = Action<typeof SET_DELETED_CLIENT_MESSAGES> & {
  deletedClientMessages: Record<number, Message>;
};

export type SetDeletedPracticeMessagesAction = Action<typeof SET_DELETED_PRACTICE_MESSAGES> & {
  deletedPracticeMessages: Record<number, Message>;
};

export type MessagesActionTypes =
  | ChangeMessagesStateAction
  | SetNewClientMessagesAction
  | SetNewPracticeMessagesAction
  | SetDeletedClientMessagesAction
  | SetDeletedPracticeMessagesAction;
